import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';



override(IndexPage.prototype, 'view', function(items) {
  var footerContent = (
    <div id='morph-footer'>
        <script>{window.location.pathname == '/all' ? document.getElementById('app').style.paddingBottom = 0 : ''}</script>
        <div id="landing-footer">
            <div class="left-side">
                <p>© Member for a day <span id="date">{new Date().getFullYear()}</span></p>
                <br></br>
                <p>Follow Member for a Day @</p>
                <p class="social-links">
                  <a href="https://www.instagram.com/memberforaday/?hl=en" target="_blank">Instagram </a> 
                  + 
                  <a href="https://twitter.com/member4aday?lang=en" target="_blank"> Twitter </a> 
                  + 
                  <a href="https://www.youtube.com/channel/UCPOh52EkRWSRq7X5ZWXiQqw" target="_blank"> Youtube </a>
                </p>
            </div>
            <div class="right-side">
                <a href={app.forum.attribute('footer.privacy_link')}>Privacy Policy</a>
                <a href={app.forum.attribute('footer.terms')}>Terms of Use</a>
                <a href={app.forum.attribute('footer.guidelines')}>Guidelines</a>
                <a href={app.forum.attribute('footer.faq')}>FAQ</a>
                <a href={'mailto:' + app.forum.attribute('footer.email')} >Contact Us</a>
            </div> 
        </div>
    </div>
  )
  var content = items()
  content.children.push(footerContent)
  return content
});

// override(DiscussionPage.prototype, 'view', function(items) {
//   var content = items()
//   console.log(content.children[1].children[1]?.children[0]?.children)
//   content.children.push(footerContent)
//   return content
// });


// extend(HeaderPrimary.prototype, 'items', function(items) {
//   items.add(
//     'title',
//     <div class="header-title">
//       <p class='title-items'>Member For A Day</p>
//       <h2 class='title-items'>THE CLUBHOUSE</h2>
//     </div>,
//     5
//   );
// });